import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  Title,
  Subtitle,
  Col,
  ButtonSubmit,
  ButtonLink,
} from '../../../styles';

// Estado que colapsa Rejected e NotFound: a solicitação não pôde ser aprovada
// (rejeitada, expirada ou inexistente) e o Requester pode solicitar novamente.
const WorkstationTryAgain = ({ onRequestAgain, onBack }) => {
  const [t] = useTranslation('login');

  return (
    <Col>
      <Title>{t('workstation.try-again.title')}</Title>
      <Subtitle>{t('workstation.try-again.subtitle')}</Subtitle>
      <ButtonSubmit block color="primary" onClick={onRequestAgain}>
        {t('workstation.try-again.cta')}
      </ButtonSubmit>
      <ButtonLink color="link" onClick={onBack}>
        {t('workstation.try-again.back')}
      </ButtonLink>
    </Col>
  );
};

export default WorkstationTryAgain;

WorkstationTryAgain.propTypes = {
  onRequestAgain: propTypes.func.isRequired,
  onBack: propTypes.func.isRequired,
};
